import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'output']

  connect () {
    this.inputTargets.forEach((input) => this.refresh(input))
  }

  update (event) {
    this.refresh(event.target)
  }

  refresh (input) {
    const length = (input.value || '').length
    const softMin = parseInt(input.dataset.softMin || '275', 10)
    const softMax = parseInt(input.dataset.softMax || '650', 10)
    const output = input.parentElement?.querySelector('[data-ntr-character-counter-target="output"]')
    if (!output) return

    let hint = `${length} / ${softMax}`
    if (length > 0 && length < softMin) hint += ` (soft min ${softMin})`
    if (length > softMax) hint += ' — too long'
    output.textContent = hint
    output.classList.toggle('text-error', length > softMax)
  }
}
